











import Vue from 'vue';

export default Vue.extend({
  name: 'TitleChunk',
  props: {
    title: String,
    secondTitle: String
  }
});
